const _cfg            = window.pawPopup || {};
const PAW_FORM_ID     = _cfg.formId            || 'Vktvfx';
const SUPPRESS_DAYS   = _cfg.suppressDays      || 7;
const DELAY_NO_ACTION = (_cfg.delayNoAction    || 90)  * 1000;
const DELAY_PREVIEW   = (_cfg.delayAfterPreview|| 10)  * 1000;
const SUPPRESS_KEY    = 'paw_popup_suppressed_until';

const ATC_SELECTORS = [
  '[data-add-to-cart]',
  '#btn__theme__add--cart',
  ".btn-add-to-cart",
  ".tee-btn.tee-btn--atc",
  ".btn.add_to_cart",
  "#customily-cart-btn",
  "#btn-add-when-preview"
];

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function matchesAny(el, selectors) {
  return selectors.some(function (sel) { return el.closest(sel); });
}

let timerNoAction  = null;
let timer10        = null;
let previewClicked = false;
let atcClicked     = false;
let popupShown     = false;

// ── helpers ──────────────────────────────────────────────────────────────────

function isProductPage() {
  const lists = [
    '/products/',
  ];
  return lists.some(path => window.location.pathname.includes(path));
}

function isSuppressed() {
  const until = localStorage.getItem(SUPPRESS_KEY);
  return until ? Date.now() < parseInt(until, 10) : false;
}

function openPopup() {
  if (isSuppressed() || popupShown) return;
  popupShown = true;

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', PAW_FORM_ID]);
}

// ── frequency: suppress after close / submit ──────────────────────────────────

window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type === 'submit') {
    localStorage.setItem(SUPPRESS_KEY, Number.MAX_SAFE_INTEGER);
  } else if (e.detail.type === 'close') {
    if (localStorage.getItem(SUPPRESS_KEY) === String(Number.MAX_SAFE_INTEGER)) return;
    localStorage.setItem(SUPPRESS_KEY, Date.now() + SUPPRESS_DAYS * 86400000);
  }
});

// ── click delegation (set up once) ───────────────────────────────────────────

document.addEventListener('click', function (e) {

  // ATC button
  if (matchesAny(e.target, ATC_SELECTORS)) {
    atcClicked = true;
    clearTimeout(timer10);
    timer10 = null;
  }
});

function onPreviewModelLoaded() {
  if (previewClicked) return;
  previewClicked = true;
  clearTimeout(timerNoAction);
  timerNoAction = null;

  if (!isProductPage()) return;

  if (!atcClicked) {
    timer10 = setTimeout(function () {
      if (!atcClicked && isProductPage()) openPopup();
    }, DELAY_PREVIEW);
  }
}

// preview model of customily
waitForElm('.cl-preview-wrapper').then(onPreviewModelLoaded);

// preview model of customall
waitForElm('.preview-wrapper .product-images-wrapper').then(onPreviewModelLoaded);

// preview model of teeblue
waitForElm('.tee-dialog-inner .tee-mockup').then(onPreviewModelLoaded);

// ── page init (runs on every navigation) ─────────────────────────────────────

function initPage() {
  clearTimeout(timerNoAction);
  clearTimeout(timer10);
  previewClicked = false;
  atcClicked     = false;
  popupShown     = false;
  timerNoAction  = null;
  timer10        = null;

  if (_cfg.enabled === false || !isProductPage()) return;

  timerNoAction = setTimeout(function () {
    if (!previewClicked && isProductPage()) openPopup();
  }, DELAY_NO_ACTION);
}

// ── navigation listeners ──────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', initPage);

let lastUrl = location.href;

new MutationObserver(function () {
  const url = location.href;
  if (url !== lastUrl) {
    lastUrl = url;
    initPage();
  }
}).observe(document, { subtree: true, childList: true });
